import { PipelineVariablesValues } from '../types';

export const filterVariables = (
  variables: {
    name: string;
    default?: string;
    allowedValues?: string[];
    description?: string;
  }[],
  variablesValues: PipelineVariablesValues
): { key: string; value: string; secured: boolean }[] => {
  return variables
    .filter(
      variable =>
        variablesValues[variable.name]?.value !== undefined ||
        variable.default !== undefined
    )
    .map(variable => ({
      key: variable.name,
      value:
        variablesValues[variable.name]?.value !== undefined
          ? (variablesValues[variable.name]?.value as string)
          : (variable.default as string),
      secured: variablesValues[variable.name]?.secured || false,
    }));
};
